import Modal from 'flarum/common/components/Modal';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

export default class LoadingDependenciesModal extends Modal {
    static isDismissible = false;

    className() {
        return 'CimaiseLoadingDependenciesModal Modal--small';
    }

    title() {
        return 'Loading Editor'; //TODO
    }

    content() {
        return LoadingIndicator.component();
    }
}
